'use client';

import { getTagsFileUrl, getTagsDomain } from 'utils/tags';
import { useRef, useEffect, useState } from 'react';

export default function TagsIframe() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const tagsDomain = getTagsDomain();
  const [tagsUrl, setTagsUrl] = useState('');

  useEffect(() => {
    // Ensure the iframe reloads when the page is reloaded
    // eslint-disable-next-line react-hooks/set-state-in-effect -- needs Date.now() cache buster, only runs on mount
    setTagsUrl(`${getTagsFileUrl('chime-com-gtm')}?_=${Date.now()}`);
  }, []);

  const initGtm = () => {
    const message = 'init';
    const properties = {
      windowState: window.history.state,
      path: window.location.pathname,
      params: window.location.search,
    };

    iframeRef.current?.contentWindow?.postMessage({ message, properties }, tagsDomain);
  };

  if (!tagsUrl) return null;

  return (
    <iframe
      ref={iframeRef}
      title="Google Tag Manager (tags.chime.com)"
      id="tags_gtm"
      src={tagsUrl}
      sandbox="allow-same-origin allow-scripts"
      onLoad={initGtm}
      style={{
        width: 0,
        height: 0,
        border: 0,
        visibility: 'hidden',
        position: 'absolute',
      }}
    />
  );
}
